export {
  getAnonymousName,
  getAnonymousAvatarUrl,
  getPrivateAvatarUrl,
  getAnonymousNameWithoutAnimal as getPrivateAnonymousName,
} from './get-anonymous-asset.ts';
export type { AnonymousAsset } from './anonymous-assets.ts';
